import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './context/LanguageContext';
import LandingPage from './pages/LandingPage';
import LocationPage from './pages/LocationPage';
import GalleryPage from './pages/GalleryPage';

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            {/* Main page - Surabaya (original, SEO preserved) */}
            <Route path="/" element={<LandingPage />} />
            
            {/* Gallery for main page */}
            <Route path="/gallery" element={<GalleryPage />} />
            
            {/* Redirect /standorte/surabaya to main page to avoid duplicate content */}
            <Route path="/standorte/surabaya" element={<Navigate to="/" replace />} />
            <Route path="/standorte/surabaya/gallery" element={<Navigate to="/gallery" replace />} />
            
            {/* Location pages with dynamic slug (Kuala Lumpur, Tunis, etc.) */}
            <Route path="/standorte/:slug" element={<LocationPage />} />
            <Route path="/standorte/:slug/gallery" element={<GalleryPage />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
